var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDogWelfare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Dog-Sit--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dog Sit Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14c0 -4.94 -2.88 -5 -3 -5a0.49 0.49 0 0 0 -0.4 0.21 0.51 0.51 0 0 0 -0.08 0.45 8 8 0 0 1 0 3.74 5.43 5.43 0 0 1 -1.46 2.89 9.54 9.54 0 0 0 -2.83 -2.47C14.38 12.63 12.48 11.38 12 8V5C12 2.82 9.46 0.25 9.35 0.15A0.49 0.49 0 0 0 8.94 0a0.5 0.5 0 0 0 -0.37 0.24l-1.4 2.29A11.28 11.28 0 0 0 5.31 3a3.82 3.82 0 0 0 -2.22 2.1L1 5.8a1.5 1.5 0 0 0 -1 1.42v1a1.51 1.51 0 0 0 1.14 1.44 15.34 15.34 0 0 0 1.54 0.22C4 10 6 10.27 6 11l0 3.7a0.32 0.32 0 0 1 -0.26 0.33 0.34 0.34 0 0 1 -0.39 -0.17l-0.89 -1.65a2.32 2.32 0 0 0 -2 -1.21C1 12 0.11 12.75 0.11 14a0.5 0.5 0 0 0 0.5 0.5h1.22l2.08 3.26A2.68 2.68 0 0 0 6.11 19v2.57a2.5 2.5 0 0 0 -2 1.95 0.5 0.5 0 0 0 0.5 0.5h3a1.5 1.5 0 0 0 1.5 -1.5V20l1.47 0.89a0.25 0.25 0 0 0 0.32 -0.06 3.75 3.75 0 0 1 3 -1.11 0.75 0.75 0 0 1 0 1.5 2.73 2.73 0 0 0 -2.84 2.09 0.49 0.49 0 0 0 0.07 0.45 0.49 0.49 0 0 0 0.41 0.21H16a3.92 3.92 0 0 0 3 -1.15A4.89 4.89 0 0 0 20 19a4.09 4.09 0 0 0 2.55 -1A5.15 5.15 0 0 0 24 14ZM6.25 6.75a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDogWelfare);
export default ForwardRef;